import { ACTIVITY_TYPE } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";
import { TAB_CODE, TIPE_PENGAJUAN_CONSTANT } from "./constant";
import React from "react";

export const constructGetDataModalCustomer = (item) => {
  return {
    name: item?.name,
    hpNumber1: item?.noTelepon,
    hpNumber2: item?.noTelepon2,
    nik: item?.nik,
    tanggalLahir: item?.tanggalLahir,
    email: item?.email,
    npwp: item?.npwp,
    address: item?.alamat,
    kkNumber: item?.kkNumber,
    province: mapToObjectDDL(
      item?.dataProvince?.provinceName,
      item?.dataProvince?.id
    ),
    kabkot: mapToObjectDDL(
      item?.dataKabKot?.kabKotName,
      item?.dataKabKot?.kabKotId
    ),
    kecamatan: mapToObjectDDL(
      item?.dataKecamatan?.kecamatanName,
      item?.dataKecamatan?.id
    ),
    kelurahan: mapToObjectDDL(
      item?.dataKelurahan?.kelurahanname,
      item?.dataKelurahan?.id
    ),
    zipCode: mapToObjectDDL(
      item?.dataKelurahan?.zipcode,
      item?.dataKelurahan?.zipcode
    ),
    gender: mapToObjectDDL(item?.gender?.value, item?.gender?.key),
    job1: mapToObjectDDL(item?.job1?.value, item?.job1?.key),
    job2: mapToObjectDDL(item?.job2?.value, item?.job2?.key),
    religion: mapToObjectDDL(item?.religion?.value, item?.religion?.key),
    memberId: item?.memberId,
    memberLevel: item?.memberLevel,
    loyaltyLevel: item?.loyaltyLevel,
    facebook: item?.facebook,
    instagram: item?.instagram,
    linkedin: item?.linkedin,
    x: item?.x,
    tiktok: item?.tiktok,
    hobby: mapToObjectDDL(item?.hobby?.[0]?.value, item?.hobby?.[0]?.key),
    interest: mapToObjectDDL(
      item?.interest?.[0]?.value,
      item?.interest?.[0]?.key
    ),
  };
};

export const handlePopulateDataAfterCheck = (data, setData, isCheckUnit) => {
  if (!isCheckUnit) {
    setData("namaPemilik", data?.namaPembeli);
    setData("alamat", data?.address);
    setData("nomorHp1", data?.hpNumber1);
    setData("nomorHp2", data?.hpNumber2);
  } else {
    setData("nik", data?.nik);
    setData("namaPemilik", data?.namaPemilik);
    setData("alamat", data?.alamat);
    setData("namaVarian", mapToObjectDDL(data?.namaVarian, data?.namaVarian));
    setData("namaWarna", mapToObjectDDL(data?.namaWarna, data?.idWarna));
    setData("kodeWarna", mapToObjectDDL(data?.kodeWarna, data?.kodeWarna));
    setData("kodeVarian", mapToObjectDDL(data?.kodeVarian, data?.kodeVarian));
    setData("nomorMesin", data?.nomorMesin);
    setData("nomorRangka", data?.nomorRangka);
    setData("tahunProduksi", data?.tahunProduksiUnit);
    setData("nomorHp1", data?.nomorHp1);
    setData("nomorHp2", data?.nomorHp2);
  }

  setData(
    "province",
    mapToObjectDDL(data.provinsi.provinceName, data.provinsi.id)
  );
  setData(
    "kabkot",
    mapToObjectDDL(data.kabkot.kabKotName, data.kabkot.kabKotId)
  );
  setData(
    "kecamatan",
    mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id)
  );
  setData(
    "kelurahan",
    mapToObjectDDL(data.kelurahan.kelurahanname, data.kelurahan.id)
  );
  setData(
    "zipcode",
    mapToObjectDDL(data.kelurahan?.zipcode, data.kelurahan?.zipcode)
  );
  setData("memberId", data?.memberId);
};

export const constructPayloadSubmit = (data) => {
  console.log(data);
  return {
    id: data.id || null,
    idClaim: data.idClaim || null,
    kodeCabang: data.kodeCabang,
    status: "ACTIVE",
    tanggalClaim: data.tanggalClaim,
    nomorClaim: data.nomorClaim,
    tipePengajuan: data.tipePengajuan?.value,
    nomorBbmPencairan: data.noBBM,
    idHotline: data.idHotline || null,
    hotline: !data.isNonHotline,
    nomorPembelian: data.nomorPembelian,
    tahunProduksiUnit: data.tahunProduksi,
    idPelapor: data.namaPelapor?.value, // employeeId
    namaPelapor: data.namaPelapor?.label,
    nomorRangka: data?.nomorRangka,
    nomorMesin: data?.nomorMesin,
    kodeVarian: data?.kodeVarian?.label,
    namaVarian: data?.namaVarian?.label,
    kodeWarna: data?.kodeWarna?.value,
    namaWarna: data?.namaWarna?.label,
    idWarna: data?.namaWarna?.value,
    namaPemilik: data?.namaPemilik,
    nik: data?.nik,
    alamat: data?.alamat,
    provinsi: data?.province?.value,
    kabkot: data?.kabkot?.value,
    kecamatan: data?.kecamatan?.value,
    kelurahan: data?.kelurahan?.value,
    kodePos: data?.zipcode?.value,
    memberId: data?.memberId,
    nomorHp1: data?.nomorHp1,
    nomorHp2: data?.nomorHp2,
    listDetail: data.dataTable?.map((item) => ({
      id: item.id || null,
      managementClaimId: item.managementClaimId || null, // diisi null jika data baru
      managementClaimDetailId: item.managementClaimDetailId || null, // diisi null jika data baru
      kodePart: item?.kodePart?.value,
      qty: Number(item?.qty),
      het: Number(item?.het),
      hetReal: Number(item?.hetReal),
      ongkosKerja: Number(item?.ongkosKerja),
    })),
  };
};

export const populateInitialData = (data, setData) => {
  setData("id", data.id);
  setData("idClaim", data.idClaim);
  setData("tanggalClaim", data.tanggalClaim);
  setData("nomorClaim", data.nomorClaim);
  setData(
    "tipePengajuan",
    TIPE_PENGAJUAN_CONSTANT.find((item) => item.value === data.tipePengajuan)
  );
  setData("noBBM", data.nomorBbmPencairan);
  setData("idHotline", data.idHotline);
  setData("nomorPembelian", data.nomorPembelian);
  setData("isNonHotline", !data.hotline);
  setData("tahunProduksi", data.tahunProduksiUnit);
  setData("namaPelapor", mapToObjectDDL(data.namaPelapor, data.idPelapor));
  setData("namaVarian", mapToObjectDDL(data?.namaVarian, data?.namaVarian));
  setData("namaWarna", mapToObjectDDL(data?.namaWarna, data?.idWarna));
  setData("kodeWarna", mapToObjectDDL(data?.kodeWarna, data?.kodeWarna));
  setData("kodeVarian", mapToObjectDDL(data?.kodeVarian, data?.kodeVarian));
  setData("nomorMesin", data?.nomorMesin);
  setData("nomorRangka", data?.nomorRangka);
  setData("namaPemilik", data?.namaPemilik);
  setData("nik", data?.nik);
  setData("alamat", data?.alamat);
  setData(
    "province",
    mapToObjectDDL(data.provinsi.provinceName, data.provinsi.id)
  );
  setData(
    "kabkot",
    mapToObjectDDL(data.kabkot.kabKotName, data.kabkot.kabKotId)
  );
  setData(
    "kecamatan",
    mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id)
  );
  setData(
    "kelurahan",
    mapToObjectDDL(data.kelurahan.kelurahanname, data.kelurahan.id)
  );
  setData("zipcode", mapToObjectDDL(data.kodePos, data.kodePos));
  setData("memberId", data?.memberId);
  setData("nomorHp1", data?.nomorHp1);
  setData("nomorHp2", data?.nomorHp2);
};

export const handleResetAutoPopulateData = (setData) => {
  setData("nik", null);
  setData("namaPemilik", null);
  setData("alamat", null);
  setData("namaVarian", null);
  setData("namaWarna", null);
  setData("kodeWarna", null);
  setData("kodeVarian", null);
  setData("nomorMesin", null);
  setData("nomorRangka", null);
  setData("tahunProduksi", null);
  setData("nomorHp1", null);
  setData("nomorHp2", null);

  setData("province", null);
  setData("kabkot", null);
  setData("kecamatan", null);
  setData("kelurahan", null);
  setData("zipcode", null);
  setData("memberId", null);
};

export const constructContentAlert = ({
  activityType,
  formData,
  placeholderIdClaim,
  tab
}) => {
  const isView = activityType === ACTIVITY_TYPE.VIEW;
  const isCreate = activityType === ACTIVITY_TYPE.CREATE;
  const isUpdate = activityType === ACTIVITY_TYPE.UPDATE;

  let title = "";
  if (isCreate) {
    title = "Penambahan data claim";
  }
  if (isView) {
    title = "Proses dilakukan pada data";
  }
  if (isUpdate) {
    title = "Perubahan dilakukan pada";
  }
  const content = (
    <div style={{ textAlign: "start" }}>
      <p>{title}</p>
      <br />
      <p>Tipe Claim: {formData.tipePengajuan?.value}</p>
      <p>ID Claim: {formData?.idClaim || placeholderIdClaim}</p>
      <p>Nomor Claim: {formData?.nomorClaim}</p>
      <p>Nama Pemilik: {formData?.namaPemilik}</p>
      {(isView || tab === TAB_CODE.LENGKAP) && formData?.noBBM && <p>Nomor BBM: {formData?.noBBM}</p>}
      <br />
      <p>dilakukan. Apakah anda yakin?</p>
    </div>
  );
  return content;
};